import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ControlsOf, FormGroup } from '@ngneat/reactive-forms';
import { Realisation } from 'src/app/classes/realisation';
import { CodaltComponent } from 'src/app/codalt.component';
import { RealisationService } from 'src/app/services/realisation.service';

@Component({
    selector: 'app-history-dialog',
    templateUrl: './history-dialog.component.html',
    styleUrls: ['./history-dialog.component.scss'],
    standalone: false,
})
export class HistoryDialogComponent extends CodaltComponent implements OnInit {
    form: FormGroup<ControlsOf<{ comment: string }>>;

    histories: History[];
    anyRemoved = true;
    anyCommentUser = true;
    anyCommentManager = true;

    constructor(
        public dialogRef: MatDialogRef<HistoryDialogComponent>,
        private realisationService: RealisationService,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            realisation: Realisation;
        }
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.realisationService.getHistory<History>(this.data.realisation.id).subscribe(history => {
                this.histories = history.data;
                this.anyRemoved = !!this.histories.find(h => !!h.removed);
                this.anyCommentUser = !!this.histories.find(h => !!h.comment_user);
                this.anyCommentManager = !!this.histories.find(h => !!h.comment_manager);
            })
        );
    }
}

class History extends Realisation {
    modified_by_user: string;
    performer_name: string;
}
